<template>
  <div :class="[layout, { 'col-md-4 col-sm-6 col-xs-12': layout == 'big', 'col-md-2 col-sm-3 col-xs-6': layout == 'small' }]"
       class="card cursor-pointer"
       @click="loginValidate()">
    <v-img :item="item" :img="item.img" :key="item.img.url" :is-video="isVideo"></v-img>
    <h5 class="q-mt-md q-mb-xs" v-html="item.title"></h5>
    <p v-if="item.subtitle" class="q-ma-none" v-html="item.subtitle"></p>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import axios from "axios"
import {Cookies} from "quasar-framework";
import watchContent from '../../plugins/watchContent'

export default {
  name: 'VCard',

  props: {
    layout: {
      type: String,
      required: true
    },
    item: {
      type: Object,
      required: true
    },
    isVideo: Boolean,
    isNotLogin: Boolean
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
    })

  },
  methods: {
    async loginValidate() {
      if (this.isNotLogin) {
        let portal = Cookies.get('portal');
        const { data } = await axios.post(`${config.SkySMSUrl}/subscription/alert`, {alias: this.item.alias, portal: portal});
        window.location.href = data;
      }
      else if (this.user) {
        if (this.user.subscription_status === 150)
          this.$login(this.item.uri.replace('/desporto/','desporto*').replace('/noticia/', 'noticia*'));
        else
          this.$router.push(this.item.uri)
      }
      else
        this.$login(this.item.uri.replace('/desporto/','desporto*').replace('/noticia/', 'noticia*'));
    }

  }

}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/front/Card.vue